import { Box, Typography, IconButton, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { Expand } from '@mui/icons-material';

interface DropdownSectionProps {
    title: string;
    children: React.ReactNode;
    defaultOpen?: boolean;
}

const DropdownSection = ({ title, children, defaultOpen = true }: DropdownSectionProps) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <Box sx={{ borderBottom: '1px solid #ddd', mb: 2 }}>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setOpen(!open)}
                sx={{ cursor: 'pointer', py: 1 }}
            >
                <Typography variant="subtitle1">{title}</Typography>
                <IconButton size="small">
                    <ExpandMoreIcon
                        sx={{
                            transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
                            transition: 'transform 0.2s'
                        }}
                    />
                </IconButton>
            </Box>

            <Collapse in={open}>
                <Box sx={{ pl: 2, pt: 1 }}>
                    {children}
                </Box>
            </Collapse>
        </Box>
    );
};

export default DropdownSection;
